import React from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useTranslation } from 'react-i18next';

// Types
import { Props, UserGroupFormValues } from './types';
import { UserGroupFormSchema } from './schema';

// Estilos: los mismos que el alta de equipos
import { Container, InputsContainer, AddTeamButton } from '../AddTeamForm/styles';

// Components
import InputText from '../../inputs/InputText';
import { Typography } from '../../display/Typography';
import { HelpTooltip } from '../../display/HelpTooltip';

export const AddUserGroupForm = ({ onCreate }: Props) => {
    const { t } = useTranslation(['management', 'common']);
    const {
        handleSubmit,
        register,
        reset,
        formState: { errors, isSubmitting },
    } = useForm<UserGroupFormValues>({
        defaultValues: { name: '' },
        resolver: yupResolver(UserGroupFormSchema) as any,
    });

    const onSubmit = async (data: UserGroupFormValues) => {
        const ok = await onCreate(data.name.trim());
        if (ok) reset({ name: '' });
    };

    return (
        <Container onSubmit={handleSubmit(onSubmit)}>
            <Typography size="L" variant="semiBold">
                {t('management:groups.addTitle')}
                {/* Qué es un grupo, en la «i» de información (feedback 2-nov):
                    como recuadro ocupaba media tarjeta. */}
                <HelpTooltip text={t('management:groups.explanation')} />
            </Typography>
            <InputsContainer>
                <InputText
                    {...register('name')}
                    label={t('common:labels.name')}
                    typeInput={'normal'}
                    inputSize="M"
                    placeholder={t('management:groups.namePlaceholder')}
                    borderError={!!errors.name?.message}
                />
                <AddTeamButton
                    type="submit"
                    disabled={isSubmitting}
                    aria-label={t('management:groups.create')}
                    title={t('management:groups.create')}
                >
                    ⮕
                </AddTeamButton>
            </InputsContainer>
        </Container>
    );
};
